An array of locations which are preferred by the candidate.

The locations are ordered in descending preference.
